module.exports = __webpack_public_path__ + "img/smsModalUA.9187b5c5.png";